import React, { useEffect, useState } from 'react';
import './index.less';
import { TokenManager } from './TokenManager';
import apiConfig from '../../config/api';
import { Spin } from 'antd';
import Cookies from 'js-cookie';
import getWechatLink from '../../config/wechatLink';
// import { useHistory } from 'react-router-dom';

const prefixUrl = `${apiConfig.gateway}/openschool-teaching-api`;
// const prefixUrl = `${apiConfig.gateway}/u-learning-bff`;
// const prefixUrl = `${apiConfig.api}`;
const navUrl = `${prefixUrl}/oauth2/authorization/${apiConfig.passport_sdk_token}`;
const Token_Key = 'openschool_token';

if (top !== window) {
  top && (top.location.href = window.location.href);
}

export function oauth2Logout() {
  const loginLink = getWechatLink();
  tokenManager.clearLocal();
  location.href = `${apiConfig.passport}/logout?return_uri=${encodeURIComponent(loginLink)}`;
}

const tokenManager = new TokenManager(
  prefixUrl,
  (token: any) => {
    console.log('token: ', token);
    Cookies.set(Token_Key, token, {
      expires: 7,
      domain: document.domain,
    });
  },
  'tokenKey:openschool-teaching',
  apiConfig.passport_sdk_token,
);

function LoginOauth() {
  // const history = useHistory();

  const [showLogin, setShowLogin] = useState(false);
  const [loading, setLoading] = useState(false);

  const query: any = {};
  new URLSearchParams(new URL(location.href).search).forEach((value, key) => {
    query[key] = value;
  });

  useListenForRedirectMessages();

  useEffect(() => {
    if (top !== window) {
      return;
    }

    window.document.title = '用户登录';

    const query: any = {};
    new URLSearchParams(new URL(location.href).search).forEach((value, key) => {
      query[key] = value;
    });
    console.log('query: ', query);

    if (query && query.code && query.nonce && query.state) {
      const { code, nonce, state } = query;
      (async function () {
        try {
          setLoading(true);
          const authRes: any = await tokenManager.getAuth({ code, nonce, state });
          console.log('authRes: ', authRes);

          if (authRes && authRes.access_token && authRes.uid) {
            // history.push(`/blank?token=${authRes.access_token}&userId=${authRes.uid}`);
            top.location.href = `/blank?token=${authRes.access_token}&userId=${authRes.uid}`;
            // await dispatch({
            //   type: 'mainAppGlobal/loginOauth',
            //   payload: {
            //     userId: authRes?.uid,
            //   },
            // });
            setLoading(false);
          } else {
            setLoading(false);
            oauth2Logout();
          }
        } catch (error) {
          console.log(error);
        }
      })();
    } else {
      setShowLogin(true);
    }
  }, []);

  return (
    <>
      {loading && (
        <Spin
          style={{
            position: 'fixed',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            height: 'auto',
            width: 'auto',
          }}
          spinning={loading}
          size="large"
          tip="登录中"
        />
      )}
      {showLogin && (
        <iframe
          style={{ display: 'block', width: '100%', height: '100vh', border: 'none' }}
          src={navUrl}
        />
      )}
    </>
  );
}

export default LoginOauth;

function useListenForRedirectMessages() {
  // 监听子窗口发送的消息，用于解决跨站的情况跳转问题
  useEffect(() => {
    if (window === top) {
      const handler = (e: any) => {
        if (e.data?.type === 'redirect') {
          window.location.href = e.data.url;
        }
      };
      window.addEventListener('message', handler);
      return () => {
        window.removeEventListener('message', handler);
      };
    }
  }, []);
}
